import { Controller } from '@hotwired/stimulus'
import { useDebounce } from 'stimulus-use'
import { timingByEnv } from '../utils'

// if you need to ignore a field element, add the data-auto-submit-ignore attribute to the element
// changing this field element will not trigger the auto-submit
export default class extends Controller {
  static targets = ['status', 'button']
  static values = {
    delay: { type: Number, default: 300 },
    event: { default: 'change', type: String }
  }
  static debounces = ['handler']

  initialize() {
    useDebounce(this, { wait: timingByEnv(this.delayValue) })
  }

  connect() {
    this.elements.forEach(el => el.addEventListener(this.eventValue, this.handler))
    this.form.addEventListener('turbo:submit-end', this.handleSubmitEnd)
  }

  disconnect() {
    this.elements.forEach(el => el.removeEventListener(this.eventValue, this.handler))
    this.form.removeEventListener('turbo:submit-end', this.handleSubmitEnd)
  }

  handleSubmitEnd = event => {
    if (event.detail.success) {
      this.handleSuccess()
    }
  }

  handler = e => {
    e.preventDefault()
    e.stopPropagation()
    this.submit()
  }

  submit() {
    // if the controller have a submit button with a form attribute, we click it
    if (this.hasButtonTarget && this.buttonTarget.type === 'submit' && this.form) {
      this.buttonTarget.click()
    } else {
      // otherwise we submit the form
      this.form.requestSubmit()
    }
    this.#toggleSavingStatus('saving')
  }

  handleSuccess() {
    this.#toggleSavingStatus('saved')

    setTimeout(() => {
      if (this.hasStatusTarget) {
        this.statusTarget.querySelector('.saved').classList.add('hidden')
      }
    }, 2000)
  }

  private

  #toggleSavingStatus(status) {
    if (!this.hasStatusTarget) return

    if (status === 'saving') {
      this.statusTarget.querySelector('.saved').classList.add('hidden')
      this.statusTarget.querySelector('.saving').classList.remove('hidden')
    } else {
      this.statusTarget.querySelector('.saved').classList.remove('hidden')
      this.statusTarget.querySelector('.saving').classList.add('hidden')
    }
  }

  get elements() {
    return Array.from(this.form.querySelectorAll('input, select, textarea')).filter(
      el => !el.hasAttribute('data-auto-submit-ignore')
    )
  }

  get form() {
    return (
      (this.hasButtonTarget && this.buttonTarget.form) ||
      this.element.querySelector('form') ||
      this.element.form ||
      this.element
    )
  }
}
